import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import Carousel from '@brainhubeu/react-carousel'
import ClubCard from './components/ClubCard'

const ClubsSection = ({
    clubs = []
}) => {
    const [slidesPerPage, setSlidesPerPage] = useState(window.innerWidth >= 768 ? 4 : 2);

    useEffect(() => {
        window.addEventListener('resize', setCardsPerScreen);
        return () => window.removeEventListener('resize', setCardsPerScreen);
    }, []);

    const setCardsPerScreen = (event) => {
        let windowSize = window.innerWidth;
        if(windowSize <= 768) {
            setSlidesPerPage(2);
        } else {
            setSlidesPerPage(4);
        }
    };

    return (
        <section className="clubs-section">
            <Container>
                <div className="info-container">
                    <h2 className="title">Clubs and Teams using ScoutAfrique</h2>
                    <p className="text">Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.</p>
                </div>
                <Carousel
                    autoPlay={3000}
                    slidesPerPage={slidesPerPage}
                    infinite
                    arrows
                >
                    {clubs.map(({ image, name }) => (
                        <ClubCard
                            key={name}
                            image={image}
                            name={name}
                        />
                    ))}
                </Carousel>
            </Container>
        </section>
    )
}

export default ClubsSection
